<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-printer-3d-nozzle</v-icon>{{ item['size'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <NozzleOutForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import NozzleOutForm from '../../components/nozzleout/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'NozzleOut';

export default {
  name: 'NozzleOutUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    NozzleOutForm
  },

  computed: {
    ...mapFields('nozzleout', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('nozzleout', ['find'])

  },

  methods: {
    ...mapActions('nozzleout', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
